import { Card, Grid, Typography } from '@mui/material';
import { canViewSecretFiles, getSubjectName, stripHTMLTags } from 'app/utils/appHelpers';
import { dshCardHeight } from 'config';
import { useSelector } from 'react-redux';
import { useTemplateFontSettings } from 'styles/templateFontSettings';
import DshBoxTitle from '../Box/DshBoxTitle';
import PreviousDStatusListTable from '../Table/PreviousDStatusListTable';
import PreviousReviewListTable from '../Table/PreviousReviewListTable';
import ReviewFileListTable from '../Table/ReviewFileListTable';
import PreviousVoteInfoListTable from '../Table/PreviousVoteInfoListTable';

function PreviousStatusCard({ decision, index, reviewsOfTheMeeting, votesOfTheMeeting, dstatusOfTheDecision, groupedData, groupedDataLink }) {

    const subjectList = useSelector(state => state.subject.data || []);
    const { authUser } = useSelector(state => state.auth);

    const { baseFontSize } = useTemplateFontSettings();

    return (
        <>
            <Card
                key={index}
                sx={{
                    m: 0,
                    p: '10px',
                    marginBottom: 0,
                    minHeight: `${dshCardHeight}`,
                    // height: `${dshPreviousCardHeight}`,
                }}
            >
                <DshBoxTitle color="primary" title={`Gündem Maddesi ${decision.decisionNo}` + " / " + getSubjectName(decision.subjectId, subjectList)} />


                <Grid container sx={{ mt: "5px", p: 0 }}>
                    <Grid item xs={12} sx={{ mb: 1, p: 0 }}>
                        <Typography
                            sx={{
                                fontSize: baseFontSize,
                                color: "primary.main",
                                lineHeight: 1.5,
                                mb: "5px",
                                p: 0,
                                fontWeight: 400
                            }}
                        >
                            Gündem
                        </Typography>
                        <p style={{ fontSize: baseFontSize, margin: 0, padding: 0, whiteSpace: "pre-line" }}>
                            {stripHTMLTags(decision.agenda)}
                        </p>
                    </Grid>

                    <Grid item xs={12} sx={{ mb: 1, p: 0 }}>
                        <Typography
                            sx={{
                                fontSize: baseFontSize,
                                color: "primary.main",
                                lineHeight: 1.5,
                                mb: "5px",
                                p: 0,
                                fontWeight: 400
                            }}
                        >
                            Karar
                        </Typography>
                        <p style={{ fontSize: baseFontSize, margin: 0, padding: 0, whiteSpace: "pre-line" }}>
                            {stripHTMLTags(decision.decision)}
                        </p>
                    </Grid>
                </Grid>


                <Grid item xs={12} sx={{ mb: 3, mt: 3, p: 0 }}>
                    <PreviousReviewListTable agendaReviews={reviewsOfTheMeeting} ></PreviousReviewListTable>
                </Grid>

                {/* <Grid item xs={12} sx={{ mb: 3, mt: 3, p: 0 }}>
                    <PreviousVoteInfoListTable agendaVotes={votesOfTheMeeting} ></PreviousVoteInfoListTable>
                </Grid> */}

                <Grid item xs={12} sx={{ mb: 3, mt: 3, p: 0 }}>
                    <PreviousDStatusListTable data={dstatusOfTheDecision} ></PreviousDStatusListTable>
                </Grid>



                {groupedData.length > 0 ? (
                    canViewSecretFiles(decision, authUser) ? (
                        <Grid item xs={12} sx={{ m: 0, p: 0 }}>
                            <ReviewFileListTable
                                groupedData={groupedData}
                                borderType={false}
                                scroll={false}
                            />
                        </Grid>
                    ) : (
                        <Grid item xs={12} sx={{ m: 0, p: 0, textAlign: "center", color: "error.main", fontSize: baseFontSize }}>
                            Gizli dosyalar - Yetkiniz bulunmamaktadır
                        </Grid>
                    )
                ) : null}

                {groupedDataLink.length > 0 ? (
                    canViewSecretFiles(decision, authUser) ? (
                        <Grid item xs={12} sx={{ mt: 2, p: 0 }}>
                            <ReviewFileListTable
                                groupedData={groupedDataLink}
                                borderType={false}
                                scroll={false}
                                dataType="link"
                            />
                        </Grid>
                    ) : (
                        <Grid item xs={12} sx={{ mt: 2, p: 0, textAlign: "center", color: "error.main", fontSize: baseFontSize }}>
                            Gizli bağlantılar - Yetkiniz bulunmamaktadır
                        </Grid>
                    )
                ) : null}
            </Card>
        </>
    );
}

export default PreviousStatusCard;